import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {SubSink} from "@Common/core/utils/subsink";
import {DomSanitizer} from "@angular/platform-browser";
import {DocumentService} from "@Services/common/document.service";
import {SnackBarToastyService, typeToast} from "@Common/widgets/general/snack-bar";
import {PubSubService} from "@Common/core/services";
import {finalize} from "rxjs/operators";
import {ResponsesService} from "../../../../common/services/responses/responses.service";


@Component({
  selector: 'app-preview-file',
  templateUrl: './preview-file.component.html',
  styleUrls: ['./preview-file.component.scss']
})
export class PreviewFileComponent implements OnInit, OnDestroy {
  subSink = new SubSink();
  virtualUrl: any;
  @Input() set pj(value: any) {
    this._downloadPieceJointe(value);
  }
  @Output() onLoading: EventEmitter<boolean> = new EventEmitter();
  canvasWidth = 800;
  canvasHeight = 600;
  constructor(private responsesSvc: ResponsesService,public sanitizer: DomSanitizer,
              private docSvc: DocumentService,
              private snackSvc: SnackBarToastyService,
              private pubSubSvc: PubSubService) {
  }

  ngOnInit() {
    const [canvasHeight, _] = this.docSvc.getScreenSize();
    this.canvasHeight = canvasHeight;
  }

  /**
   * Calcul hauteur plein écran
   */

  getHeight() {
    return this.canvasHeight - 170; // 2x16 entête Hx + footer 68 + header 20 + 20 marge
  }
  getWidth() {
    return this.canvasWidth;
  }
  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  private _downloadPieceJointe(fichier: any) {
    if (fichier) {
      this.onLoading.emit(true);
      this.pubSubSvc.publish('loading', true);

      return this.responsesSvc.getFileResponse(fichier)
        .pipe(finalize(() => {
          this.onLoading.emit(false);
          this.pubSubSvc.publish('loading', false);
        }))
        .subscribe(data => {
          this.virtualUrl = new File([data], fichier.value, {type: 'application/pdf'});
        }, error => {
          this.snackSvc.toasty('Pièce jointe', 'Impossibilité d\'obtenir la PJ', typeToast.error);
        });
    }
  }

}
